// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
// import { getStorage } from "firebase/storage";
// import { getFirestore } from "firebase/firestore";
// import firebase from 'firebase/compat/app';
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyCMlG25raCOfeAKB_39mHga8y5cYFC3ToM",
  authDomain: "swita-pandutama.firebaseapp.com",
  projectId: "swita-pandutama",
  storageBucket: "swita-pandutama.appspot.com",
  messagingSenderId: "218233209154",
  appId: "1:218233209154:web:50caf63945063ee26d08db",
  measurementId: "G-9J21Q8FZ0F"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
// const defaultStorage = getStorage();
// const defaultFirestore = getFirestore();
// const otherStorage = getStorage(app);
// const otherFirestore = getFirestore(app);
export const db = app;